function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.3,
  d: "M8.232 226.151c40.99 26.613 222.836 85.165 217.802 14.872-5.033-70.294-79.325-114.669-101.403-61.788-23.078 55.279 40.635 224.618 111.731 114.738s62.221-191.296 64.886-202.572",
  stroke: "#A3A3A3",
  strokeWidth: 2.98
});

var SvgSquiggle1 = function SvgSquiggle1(props) {
  return React.createElement("svg", _extends({
    width: 335,
    height: 349,
    viewBox: "0 0 335 349",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzM1IiBoZWlnaHQ9IjM0OSIgdmlld0JveD0iMCAwIDMzNSAzNDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuMyIgZD0iTTguMjMyMzYgMjI2LjE1MUM0OS4yMjE1IDI1Mi43NjQgMjMxLjA2OCAzMTEuMzE2IDIyNi4wMzQgMjQxLjAyM0MyMjEuMDAxIDE3MC43MjkgMTQ2LjcwOSAxMjYuMzU0IDEyNC42MzEgMTc5LjIzNUMxMDEuNTUzIDIzNC41MTQgMTY1LjI2NiA0MDMuODUzIDIzNi4zNjIgMjkzLjk3M0MzMDcuNDU4IDE4NC4wOTMgMjk4LjU4MyAxMDIuNjc3IDMwMS4yNDggOTEuNDAxMiIgc3Ryb2tlPSIjQTNBM0EzIiBzdHJva2Utd2lkdGg9IjIuOTgiLz4KPC9zdmc+Cg==";
export { SvgSquiggle1 as ReactComponent };